module.exports = __webpack_public_path__ + "static/media/certinho.ebf9604f.svg";